/**
 * This module is in charge of controlling switch visual components.
 */
(function() {

  "use strict";
  var DEFAULT_CONFIG = {
    position: 'RIGHT_TOP',

  };
  var ID = 0;

  define('fg-arv/components/zoomControl',[],function() {
    var module = {
      createComponent: function(config) {
        var container = document.createElement('div');
        container.className = 'fg-arv_zoom-component';
        if (container) {
          var id = createDomID();
          var conf = jQuery.extend({
            id: id
          }, DEFAULT_CONFIG, config);

          var map = conf.widget.getMap();
          var controls = map.controls[google.maps.ControlPosition[conf.position]].getArray();
          if (jQuery.inArray(container, controls) !== -1) {
            container = controls[jQuery.inArray(container, controls)];
          } else {
            jQuery(container).addClass('map-control');
            container.index = 3;
            google.maps.event.addListenerOnce(map, 'loaded', function() {
              var heightForm = config.widget.widgetElement.find('.form').height();
              container.style['margin-top'] = heightForm + 10 + 'px';
              map.controls[google.maps.ControlPosition[conf.position]].push(container);
              var resizeTimeout;
              jQuery(window).resize(function() {
                if (resizeTimeout) {
                  clearTimeout(resizeTimeout);
                }
                resizeTimeout = setTimeout(function() {
                  var heightForm = config.widget.widgetElement.find('.form').height();
                  container.style['margin-top'] = heightForm + 10 + 'px';
                }, 30);
              });

            });
          }

          var template = createTemplate(conf);
          container.innerHTML = template;

          var componentElement = jQuery(container).find('#' + id);
          var component = {
            getID: function() {
              return id;
            },
            init: function(conf) {

              componentElement.parent().css('margin-top', '100px !important');
              var plusbtn = componentElement.find('.zoom-control-plus');
              var minusbtn = componentElement.find('.zoom-control-minus');

              plusbtn[0].addEventListener('click', function() {
                map.setZoom(map.zoom + 1);
              });
              minusbtn[0].addEventListener('click', function() {
                map.setZoom(map.zoom - 1);
              });

            }
          };
          component.init(conf);

          return component;
        }
      }

    };

    return module;

    //*********************************************************

    function createTemplate(config) {
      return "<div id='" + config.id + "' class='zoom-control'>" +
        '<div class="btn-group btn-group-vertical" role="group" aria-label="...">' +
        '<button type="button" class="btn btn-default zoom-control-plus">+</button>' +
        '<button type="button" class="btn btn-default zoom-control-minus">-</button>' +
        '</div>' +
        "</div>";
    }

    function createDomID() {
      var i = ++ID;
      return "fg-arv-zoom-" + i;
    }

  });

})();

